import { Skeleton } from '@mui/material';
import { TitleTypography } from '../styles';

interface CheckoutTitleProps {
  title: string;
  loading?: boolean;
}

export const CheckoutTitle = ({
  title,
  loading = false,
}: CheckoutTitleProps) => {
  return (
    <>
      {loading && <Skeleton variant="rectangular" width={240} height={36} />}
      {!loading && <TitleTypography>{title}</TitleTypography>}
    </>
  );
};
